import { render, staticRenderFns } from "./KiyakuPage.vue?vue&type=template&id=6d2bb21e&scoped=true"
import script from "./KiyakuPage.vue?vue&type=script&lang=js"
export * from "./KiyakuPage.vue?vue&type=script&lang=js"
import style0 from "./KiyakuPage.vue?vue&type=style&index=0&id=6d2bb21e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2bb21e",
  null
  
)

export default component.exports